import { QuestionCircleIcon } from 'assets/images/icons';
import { Button } from 'common/ui/button';
import { Checkbox } from 'common/ui/checkbox';
import { Tooltip } from 'common/ui/tooltip';
import { Faqs, Pros } from 'context/page-form-context';
import { AiVariant, AiVariantContext, useMelContext } from 'modules/mel-ai';
import { convertFaqsToContext } from 'modules/mel-ai/utils';
import { UseFormReturn } from 'react-hook-form';

import styles from '../mel-chat-modal.module.scss';

interface MelChatModalActionsProps {
  disableContext?: boolean;
  form: UseFormReturn<AiVariantContext, any>;
  handleRequestVariant: (context?: AiVariantContext) => void;
  isFaqs: boolean;
  isSummary: boolean;
  onApply: () => void;
  onClose: () => void;
  originalContent: string | Faqs | Pros;
  selectedVariant: AiVariant;
}

const MelChatModalActions = ({
  disableContext,
  form,
  handleRequestVariant,
  isFaqs,
  isSummary,
  onApply,
  onClose,
  originalContent,
  selectedVariant,
}: MelChatModalActionsProps) => {
  const { getValues, register, watch } = form;
  const { is_new } = watch();

  const { award } = useMelContext();

  const onRegenerateContent = () => {
    const contextValue = getValues().context;
    const isNewValue = getValues().is_new;

    const context: AiVariantContext = {
      content:
        typeof originalContent === 'string'
          ? originalContent
          : isFaqs
          ? JSON.stringify(convertFaqsToContext(originalContent as Faqs))
          : JSON.stringify(originalContent),
      context: contextValue,
      dependency_content: isSummary && award ? { [award]: [originalContent as string] } : {},
      is_new: isNewValue,
    };

    handleRequestVariant(context);
    onClose();
  };

  return (
    <div className={styles.actionBtns}>
      <div className={styles.regen}>
        <Button onClick={() => onRegenerateContent()} size="small" variant="primary">
          Regenerate Content
        </Button>
        {!disableContext && (
          <Checkbox checked={is_new} {...register('is_new')}>
            Ignore Original Content
          </Checkbox>
        )}
        <Tooltip
          placement="right"
          title="Requests for new content can take time to process. Try refreshing after a few minutes."
        >
          <QuestionCircleIcon className={styles.icon} />
        </Tooltip>
      </div>
      <div className={styles.submit}>
        <Button
          disabled={!selectedVariant}
          onClick={() => onApply()}
          size="small"
          variant={selectedVariant ? 'primary' : 'secondary'}
        >
          Apply
        </Button>
        <Button onClick={() => onClose()} size="small" variant="danger">
          Close
        </Button>
      </div>
    </div>
  );
};

export { MelChatModalActions };
